import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';


import "react-datepicker/dist/react-datepicker.css";

import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {  
    fetchMskAssessment,
    editSCAssessment    
 } from 'Actions';


class EditMSKElements extends React.Component {
    static propTypes = {
        classes: PropTypes.object,
    };

    
      state = {               
               
                previousLength:0,
                valuelength:0,
                scheight:this.props.data.scheight,
                scwaist:this.props.data.scwaist,
                scweight:this.props.data.scweight,
                scbmi:this.props.data.scbmi,
                schip:this.props.data.schip,
                scwhratio:this.props.data.scwhratio,
                deepsquat_finalscore:this.props.data.deepsquat_finalscore,
                hurdlestep_r_finalscore:this.props.data.hurdlestep_r_finalscore,
                inlinelunge_r_finalscore:this.props.data.inlinelunge_r_finalscore,
                shouldermobility_r_finalscore:this.props.data.shouldermobility_r_finalscore,
                activestraightlegraise_r_finalscore:this.props.data.activestraightlegraise_r_finalscore,
                trunkstabilitypushup_finalscore:this.props.data.trunkstabilitypushup_finalscore,
                rotarystability_r_finalscore:this.props.data.rotarystability_r_finalscore,
                fmtotalscore:this.props.data.fmtotalscore,
                rmtest:this.props.data.rmtest,
                aerobictest:this.props.data.aerobictest,
                lowerbodytest:this.props.data.lowerbodytest,
                upperbody:this.props.data.upperbody,
                acceleration:this.props.data.acceleration,
                coreendurance:this.props.data.coreendurance,
                aerobicfitness_time:this.props.data.aerobicfitness_time,
                aerobicfitness_vo:this.props.data.aerobicfitness_vo,
               rmcleanestimate_rm:this.props.data.rmcleanestimate_rm,
               rmcleanestimate_value:this.props.data.rmcleanestimate_value,
               rmclean_value:this.props.data.rmclean_value,
               rmsquat_rm:this.props.data.rmsquat_rm,
               rmsquatestimate_value:this.props.data.rmsquatestimate_value,
               rmsquat_value:this.props.data.rmsquat_value,
               rmpress_rm:this.props.data.rmpress_rm,
               rmpressestimate_value:this.props.data.rmpressestimate_value,
               rmpress_value:this.props.data.rmpress_value,

               deepsquat_rawscore:this.props.data.deepsquat_rawscore,
               hurdlestep_r_rawscore:this.props.data.hurdlestep_r_rawscore,
               hurdlestep_l_rawscore:this.props.data.hurdlestep_l_rawscore,
               inlinelunge_r_rawscore:this.props.data.inlinelunge_r_rawscore,
               inlinelunge_l_rawscore:this.props.data.inlinelunge_l_rawscore,
               shouldermobility_r_rawscore:this.props.data.shouldermobility_r_rawscore,
               shouldermobility_l_rawscore:this.props.data.shouldermobility_l_rawscore,
               activestraightlegraise_r_rawscore:this.props.data.activestraightlegraise_r_rawscore,
               activestraightlegraise_l_rawscore:this.props.data.activestraightlegraise_l_rawscore,
               rotarystability_r_rawscore:this.props.data.rotarystability_r_rawscore,
               rotarystability_l_rawscore:this.props.data.rotarystability_l_rawscore,
               trunkstabilitypushup_rawscore:this.props.data.trunkstabilitypushup_rawscore,

               boxjump_score:this.props.data.boxjump_score,
               singlerighthopright_score:this.props.data.singlerighthopright_score,
               singlerighthopleft_score:this.props.data.singlerighthopleft_score,
               deadlift_score:this.props.data.deadlift_score,
               pullup_score:this.props.data.pullup_score,
               pushup_score:this.props.data.pushup_score,
               plank_score:this.props.data.plank_score,
               medicineball_score:this.props.data.medicineball_score,

               bgColor:this.props.data.bgColor,
               gender:this.props.data.gender,
               wabgColor:this.props.data.wabgColor,

               lowerboay_trial1:this.props.data.lowerboay_trial1,
               lowerboay_trial2:this.props.data.lowerboay_trial2,
               lowerboay_trial3:this.props.data.lowerboay_trial3,
               lowerboay_result:this.props.data.lowerboay_result,
               acceleration_trial1:this.props.data.acceleration_trial1,
               acceleration_trial2:this.props.data.acceleration_trial2,
               acceleration_trial3:this.props.data.acceleration_trial3,
               acceleration_result:this.props.data.acceleration_result,
    };
  
   handleInput(event) {
      const bullet = "\u2022";
      const inputValue = event.target.value;
      const cursorPosition = event.target.selectionStart;
      let lines = inputValue.split('\n');
    
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        if (!line.trim().startsWith(bullet)) {
          lines[i] = `${bullet} ${line.trimLeft()}`;
        }
      }
    
      let newValue = lines.join('\n');
      if (event.nativeEvent.inputType === 'deleteContentBackward') {
        if (cursorPosition === 0) {
          const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
          if (lineIndex > 0) {
            const linesArray = newValue.split('\n');
            linesArray.splice(lineIndex, 1);
            newValue = linesArray.join('\n');
          }
        } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
          newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
        }
      }
    
      event.target.value = newValue;
    
      this.setState({
        previousLength: newValue.length,
      });
   }

   calculateBMI(evt, frm){
      if(frm==1){
          var height=evt.target.value;
          this.setState({ 
             scheight:height
          });
          var weight=this.state.scweight;
      }else{
          var weight=evt.target.value;
          this.setState({ 
             scweight:weight
          });
          var height=this.state.scheight;
      }
      let meter = height / 100;
      let value= weight/(meter*meter);
      let bmi= Number((value).toFixed(2));
      if(bmi==0){
        var colorcode='#F4F7FA'; 
      }else if(bmi<='17.9'){
         var colorcode='#e6cc00';
      }else if(bmi>='18.0'&&bmi<='24.9'){
        var colorcode='#00c04b';
      }else if(bmi>='25.0'&&bmi<='29.9'){ 
        var colorcode='#F27F0C';        
      }else if(bmi>='30'){  
        var colorcode='#de0a26';
      }
      this.setState({ 
          scbmi:bmi,
          bgColor:colorcode
      });
      
   }

   calculateWaist(evt,frm){
         var gender=this.state.gender;
         
         if(frm==1){
            var waist=evt.target.value;
            this.setState({ 
               scwaist:waist
            });
            var hip=this.state.schip;
         }else{
            var hip=evt.target.value;
            this.setState({ 
               schip:hip
            });
            var waist=this.state.scwaist;
         } 
            
            let value = parseFloat(waist) / parseFloat(hip);
            let ratio= Number((value).toFixed(2));


         if(gender==1){
            if(ratio==0){
               var colorcode='#F4F7FA'; 
            }else if(ratio<='0.95'){
               var colorcode='#4DED30';
            }else if(ratio>='0.96'&&ratio<='1.0'){
               var colorcode='#F27F0C';   
            }else if(ratio>='1.0'){  
               var colorcode='#de0a26';
            }
         }else{
            if(ratio==0){
               var colorcode='#F4F7FA'; 
            }else if(ratio<='0.80'){
               var colorcode='#4DED30';
            }else if(ratio>='0.81'&&ratio<='0.84'){
               var colorcode='#F27F0C';   
            }else if(ratio>='0.85'){  
               var colorcode='#de0a26';
            }
         }
     
      this.setState({ 
          scwhratio:ratio,
          wabgColor:colorcode
      });
   }

   calculateVO(evt){
      var voval=evt.target.value;     
      var sumvoal=3.079*voval;
      var rndval=sumvoal.toFixed(2);
      var total= 85.95-rndval;
      var sumtotal=total.toFixed(2);
      this.setState({ 
         aerobicfitness_time: voval,
         aerobicfitness_vo: sumtotal
      });
      

   }

   isNumeric(e){
 
      var value=e.target.value;
      var name=e.target.name;
      
      if(value<=3){
         var entval='';
         this.setState({[name]: value});
      
      }else{
         this.setState({[name]: ''});
      }

      
   }

   calculateRawScore(evt){

         let value=evt.target.value;  
         let name=evt.target.name;  

         var sdd=name.split('_');
         var fnalname=sdd[0]+"_finalscore";

         if(value<=3){

            this.setState({ 
               [name]: value,
               [fnalname]: value
            }); 
            this.totalsum(fnalname, value);
         }else{
            this.setState({ 
               [name]: '',
               [fnalname]: 0
            }); 
         }   
   }

   calculateRightLeft(evt,id){

         let value=evt.target.value;  
         let name=evt.target.name;  
         if(value<=3){
            this.setState({ 
               [name]: value
            }); 
            
            var ehname=name.split('_');
            if(id==1){             
               var chkname=ehname[0]+"_l_"+ehname[2];             
               var checkvalue=this.state[chkname];
            }else{
               var chkname=ehname[0]+"_r_"+ehname[2];
               var checkvalue=this.state[chkname];
            }

            if(parseInt(value)<parseInt(checkvalue)){
               var finalval=value;  
            }else{
               var finalval=checkvalue;   
            }
         
            var fnalname=ehname[0]+"_r_finalscore";
            this.setState({ 
               [fnalname]: finalval
            }); 
            this.totalsum(fnalname, finalval);
         }else{
            this.setState({ 
               [name]: ''
            });
         }   
   }


   calculateTotalScore(evt){

      let value=evt.target.value;  
      let name=evt.target.name;      
      this.setState({ 
         [name]: value
      });
      
      this.totalsum(name, value);
            
   }

   
   totalsum(name, value){
      var { deepsquat_finalscore, hurdlestep_r_finalscore, inlinelunge_r_finalscore, shouldermobility_r_finalscore, activestraightlegraise_r_finalscore, trunkstabilitypushup_finalscore, rotarystability_r_finalscore} = this.state;   
      
      if(name=='deepsquat_finalscore'){
          if(value==''){
            deepsquat_finalscore=0;
          }else{
            deepsquat_finalscore=value;
          }
          
      }else if(name=='hurdlestep_r_finalscore'){
         if(value==''){
            hurdlestep_r_finalscore=0;
          }else{
            hurdlestep_r_finalscore=value;
          }

      }else if(name=='inlinelunge_r_finalscore'){
         if(value==''){
            inlinelunge_r_finalscore=0;
         }else{
            inlinelunge_r_finalscore=value;
         }
      }else if(name=='shouldermobility_r_finalscore'){
         if(value==''){
            shouldermobility_r_finalscore=0;
         }else{
            shouldermobility_r_finalscore=value;
         }
      
      }else if(name=='activestraightlegraise_r_finalscore'){
         if(value==''){
            activestraightlegraise_r_finalscore=0;
         }else{
            activestraightlegraise_r_finalscore=value;
         }
      }else if(name=='trunkstabilitypushup_finalscore'){
         if(value==''){
            trunkstabilitypushup_finalscore=0;
         }else{
            trunkstabilitypushup_finalscore=value;
         }
      
      }else if(name=='rotarystability_r_finalscore'){
         if(value==''){
            rotarystability_r_finalscore=0;
         }else{
            rotarystability_r_finalscore=value;
         }
      }

      
      var totalscore = parseFloat(deepsquat_finalscore)+parseFloat(hurdlestep_r_finalscore)+parseFloat(inlinelunge_r_finalscore)+parseFloat(shouldermobility_r_finalscore)+parseFloat(activestraightlegraise_r_finalscore)+parseFloat(trunkstabilitypushup_finalscore)+parseFloat(rotarystability_r_finalscore);
      
      this.setState({ 
         fmtotalscore:totalscore
      });
   }

    handleAddCheckChange(val){
        if(val==1){
            let { rmtest } = this.state;
            if(rmtest==false){
                this.setState({ 
                    rmtest:true
                });
            }else{
                this.setState({ 
                    rmtest:false
                }); 
            }
        }else if(val==2){
            let { aerobictest } = this.state;
            if(aerobictest==false){
                this.setState({ 
                    aerobictest:true
                });
            }else{
                this.setState({ 
                    aerobictest:false
                }); 
            }
        }else if(val==3){
            let { lowerbodytest } = this.state;
            if(lowerbodytest==false){
                this.setState({ 
                    lowerbodytest:true
                });
            }else{
                this.setState({ 
                    lowerbodytest:false
                }); 
            }
        }else if(val==4){
            let { upperbody } = this.state;
            if(upperbody==false){
                this.setState({ 
                    upperbody:true
                });
            }else{
                this.setState({ 
                    upperbody:false
                }); 
            }
        }else if(val==5){
            let { acceleration } = this.state;
            if(acceleration==false){
                this.setState({ 
                    acceleration:true
                });
            }else{
                this.setState({ 
                    acceleration:false
                }); 
            }
        }else if(val==6){
            let { coreendurance } = this.state;
            if(coreendurance==false){
                this.setState({ 
                    coreendurance:true
                });
            }else{
                this.setState({ 
                    coreendurance:false
                }); 
            }
        }
    }

   rmCalculate(evt,val){
         let value=evt.target.value;  
         let name=evt.target.name;      
         this.setState({ 
            [name]: value
         });

         this.rmTotalvalue(value,val);
   }

   rmTotalvalue(currentvalue,val){
         var { rmcleanestimate_rm, rmsquat_rm, rmpress_rm } = this.state; 
         
         if(val==1){
            var mulrm=0.0278*rmcleanestimate_rm;
            var minrm=1.0278-mulrm;
            var calvalue=currentvalue/minrm;
            var sumvalue=calvalue.toFixed(2);
            this.setState({ 
               rmclean_value: sumvalue
            });
         }else if(val==2){
            var mulrm=0.0278*rmsquat_rm;
            var minrm=1.0278-mulrm;
            var calvalue=currentvalue/minrm;
            var sumvalue=calvalue.toFixed(2);
            this.setState({ 
               rmsquat_value: sumvalue
            });
         }else if(val==3){
            var mulrm=0.0278*rmpress_rm;
            var minrm=1.0278-mulrm;
            var calvalue=currentvalue/minrm;
            var sumvalue=calvalue.toFixed(2);
            this.setState({ 
               rmpress_value: sumvalue
            });
         }
   } 

   lowerbody(evt,val){
         let value=evt.target.value;  
         let name=evt.target.name;      
         this.setState({ 
            [name]: value
         });

         if(val==1){
            var trail1=value;
            var trail2=this.state.lowerboay_trial2;
            var trail3=this.state.lowerboay_trial3;
         }else if(val==2){
            var trail1=this.state.lowerboay_trial1;
            var trail2=value;
            var trail3=this.state.lowerboay_trial3;
         }else{
            var trail1=this.state.lowerboay_trial1;
            var trail2=this.state.lowerboay_trial2;
            var trail3=value;
         }

         let result = Math.max(trail1, trail2, trail3);
         this.setState({ 
            lowerboay_result: result
         });
   }

   acceleration(evt,val){
      let value=evt.target.value;  
      let name=evt.target.name;      
      this.setState({ 
         [name]: value
      });

      if(val==1){
         var trail1=value;
         var trail2=this.state.acceleration_trial2;
         var trail3=this.state.acceleration_trial3;
         var result='';
         if(trail2!=""&&trail3==""){
            result = Math.min(trail1, trail2);
         }else if(trail3!=""&&trail2==""){
            result = Math.min(trail1, trail3);  
         }else if(trail1!=""&&trail2!=""&&trail3!=""){
            result = Math.min(trail1, trail2, trail3);  
         }else{
            result = trail1;  
         }
      }else if(val==2){
         var trail1=this.state.acceleration_trial1;
         var trail2=value;
         var trail3=this.state.acceleration_trial3;
         if(trail1!=""&&trail3==""){
            result = Math.min(trail2, trail1);
         }else if(trail3!=""&&trail1==""){
            result = Math.min(trail2, trail3);  
         }else if(trail1!=""&&trail2!=""&&trail3!=""){
            result = Math.min(trail1, trail2, trail3);  
         }else{
            result = trail2;  
         }
      }else{
         var trail1=this.state.acceleration_trial1;
         var trail2=this.state.acceleration_trial2;
         var trail3=value;
         if(trail1!=""&&trail2==""){
            result = Math.min(trail3, trail1);               
         }else if(trail2!=""&&trail1==""){
            result = Math.min(trail3, trail2);  
         }else if(trail1!=""&&trail2!=""&&trail3!=""){
            result = Math.min(trail1, trail2, trail3);  
         }else{
            result = trail3;  
         }
      }

      this.setState({ 
         acceleration_result: result
      });
}

    editHandleSubmit(event){
        event.preventDefault();
        let { rmtest, aerobictest, lowerbodytest, upperbody, acceleration, coreendurance } = this.state;   
        this.props.editSCAssessment(event, rmtest, aerobictest, lowerbodytest, upperbody, acceleration, coreendurance).then((data) => {         
           if(data.status==1){
                 setTimeout(this.props.onClick, 6000);
           }
        });
        
    }

    
    render() {
      
        const { scresponse, loading} = this.props;
        const studentname=scresponse.student; 
        return (
            
            <div>
               
               <div className="col-md-12">
                     <form autoComplete="off" id="editassessmentform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <RctCollapsibleCard heading="Edit Strength & Conditioning">                              
                                    <div className="row">
                                        <div className="col-sm-12 col-md-8"> 
                                                <h3>{studentname}</h3>                                             
                                        </div> 
                                        <div className="col-sm-12 col-md-2">  
                                            <input type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} value="Back" />
                                        </div>     
                                        <div className="col-sm-12 col-md-8"> 
                                            <FormGroup>
                                                <Label for="Select">S&C Assessor *</Label>
                                                <Input type="text" name="scassessor" id="scassessor" required defaultValue={scresponse.scassessor} />
                                            </FormGroup>
                                        </div> 
                                    </div>    
                                </RctCollapsibleCard>  
                           </div>

                            <div className="col-sm-12 col-md-6">
                            <RctCollapsibleCard>                              
                                    <div className="row">
                                        <div className="col-sm-12 col-md-8"> 
                                            <FormGroup>
                                                <Label for="Select">Skill</Label>
                                                <textarea rows="2" type="text" name="mskskill" id="mskskill" className="form-control form-control-alternative" defaultValue={scresponse.mskskill}></textarea>
                                            </FormGroup>
                                        </div> 
                                        <div className="col-sm-12 col-md-8"> 
                                            <FormGroup>
                                                <Label for="Select">Medical History</Label>
                                                <textarea rows="2" type="text" name="medicalhistory" id="medicalhistory" className="form-control form-control-alternative" defaultValue={scresponse.medicalhistory} onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup>
                                        </div> 
                                        <div className="col-sm-12 col-md-8"> 
                                          <FormGroup>
                                             <Label for="Select">Medical Record</Label>
                                             <Input type="select" name="medicalrecord" id="medicalrecord" defaultValue={scresponse.medicalrecord}>
                                                <option value=""> </option>
                                                <option value="Submitted">Submitted</option>
                                                <option value="Awaited">Awaited</option>
                                                <option value="Not Relevant"> Not Relevant</option>                                                
                                             </Input>
                                          </FormGroup>
                                       </div>
                                        <div className="col-sm-12 col-md-8"> 
                                            <FormGroup>
                                                <Label for="Select">Allergies</Label>
                                                <textarea rows="2" type="text" name="allergies" id="allergies" className="form-control form-control-alternative" defaultValue={scresponse.allergies} onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup>
                                        </div> 
                                        <div className="col-sm-12 col-md-8"> 
                                          <FormGroup>
                                             <Label for="Select">Injury History</Label>
                                             <textarea rows="2" type="text" name="injuryhistory" id="injuryhistory" className="form-control form-control-alternative"  defaultValue={scresponse.injuryhistory} onChange={evt => this.handleInput(evt)}></textarea>
                                          </FormGroup>
                                       </div> 
                                    </div>
                            </RctCollapsibleCard>  
                            </div> 
                        </div>                  

                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                              <h3 className="text-center">STRENGTH & CONDITIONING ASSESSMENT </h3>
                           </div> 
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                              <RctCollapsibleCard heading="ANTHROPOMETRIC ASSESSMENT"> 
                                 <div className="row">
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">Height (cm)</Label>
                                             <Input type="text" name="scheight" id="scheight" value={this.state.scheight} onChange={evt => this.calculateBMI(evt,1)}/>
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">Weight (kg)</Label>
                                             <Input type="text" name="scweight" id="scweight" value={this.state.scweight} onChange={evt => this.calculateBMI(evt,2)}  />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">BMI(kg/m<sup style={{top: "-5px"}}>2</sup>)</Label>
                                             <Input type="text" name="scbmi" id="scbmi" style={{backgroundColor: this.state.bgColor, fontWeight: "600", color: "#fff"}} value={this.state.scbmi} disabled/>
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">Waist (cm)</Label>
                                             <Input type="text" name="scwaist" id="scwaist" value={this.state.scwaist} onChange={evt => this.calculateWaist(evt,1)} />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">Hip (cm)</Label>
                                             <Input type="text" name="schip" id="schip" value={this.state.schip} onChange={evt => this.calculateWaist(evt,2)} />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">Waist to Hip Ratio</Label>
                                             <Input type="text" name="scwhratio" id="scwhratio" style={{backgroundColor: this.state.wabgColor, fontWeight: "600", color: "#fff"}} value={this.state.scwhratio} disabled/>
                                          </FormGroup>
                                       </div>
                                 </div>  
                                 <div className="row">
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">UA Right (cm)</Label>
                                             <Input type="text" name="scuaright" id="scuaright" defaultValue={scresponse.scuaright} />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">UA Left (cm)</Label>
                                             <Input type="text" name="scualeft" id="scualeft" defaultValue={scresponse.scualeft} />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">Mid Thigh Right (cm)</Label>
                                             <Input type="text" name="scmidthighright" id="scmidthighright" defaultValue={scresponse.scmidthighright} />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">Mid Thigh Left (cm)</Label>
                                             <Input type="text" name="scmidthighleft" id="scmidthighleft" defaultValue={scresponse.scmidthighleft} />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">Mid Calf Right (cm)</Label>
                                             <Input type="text" name="scmidcalfright" id="scmidcalfright" defaultValue={scresponse.scmidcalfright} />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-6 col-md-2"> 
                                          <FormGroup>
                                             <Label for="Select">Mid Calf Left (cm)</Label>
                                             <Input type="text" name="scmidcalfleft" id="scmidcalfleft" defaultValue={scresponse.scmidcalfleft} />
                                          </FormGroup>
                                       </div>
                                 </div>
                                 <div className="row">
                                       <div className="col-sm-12 col-md-6"> 
                                          <FormGroup>
                                             <Label for="Select">Impression </Label>
                                             <textarea rows="2" type="text" name="sc_impression" id="sc_impression" className="form-control form-control-alternative" defaultValue={scresponse.sc_impression} onChange={evt => this.handleInput(evt)}></textarea>
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-12 col-md-6"> 
                                          <FormGroup>
                                             <Label for="Select">Approach </Label>
                                             <textarea rows="2" type="text" name="sc_approach" id="sc_approach" className="form-control form-control-alternative" defaultValue={scresponse.sc_approach} onChange={evt => this.handleInput(evt)}></textarea>
                                          </FormGroup>
                                       </div>
                                 </div>          
                              </RctCollapsibleCard>
                            </div> 

                            <div className="col-sm-12 col-md-8">
                              <RctCollapsibleCard heading="FUNCTIONAL MOVEMENT SCREENING"> 
                                    <table className="table align-items-center table-flush">
                                          <thead className="thead-light">
                                             <th className="text-center" colSpan="2" style={{width: "20%"}}>Test</th>
                                             <th className="text-center" style={{width: "10%"}}>Raw Score</th>
                                             <th className="text-center" style={{width: "10%"}}>Final Score</th>
                                             <th className="text-center">Comments</th>
                                          </thead>
                                          <tbody>
                                             <tr>
                                                <td colSpan="2">Deep Squat </td>
                                                <td><input type="text" name="deepsquat_rawscore" id="deepsquat_rawscore" className="form-control form-control-alternative" value={this.state.deepsquat_rawscore}  onChange={evt => this.calculateRawScore(evt)}/></td>
                                                <td><input type="text" name="deepsquat_finalscore" id="deepsquat_finalscore" className="form-control form-control-alternative" value={this.state.deepsquat_finalscore}  onChange={evt => this.calculateTotalScore(evt)} disabled/></td>
                                                <td><textarea rows="2" type="text" name="deepsquat_comments" id="deepsquat_comments" className="form-control form-control-alternative" defaultValue={scresponse.deepsquat_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td rowSpan="2">Hurdle Step</td>
                                                <td>R</td>
                                                <td><input type="text" name="hurdlestep_r_rawscore" id="hurdlestep_r_rawscore" className="form-control form-control-alternative" value={this.state.hurdlestep_r_rawscore}  onChange={evt => this.calculateRightLeft(evt,1)}/></td>
                                                <td rowSpan="2"><textarea rows="2" type="text" name="hurdlestep_r_finalscore" id="hurdlestep_r_finalscore" className="form-control form-control-alternative" value={this.state.hurdlestep_r_finalscore}  onChange={evt => this.calculateTotalScore(evt)} disabled></textarea></td>
                                                <td><textarea rows="2" type="text" name="hurdlestep_r_comments" id="hurdlestep_r_comments" className="form-control form-control-alternative" defaultValue={scresponse.hurdlestep_r_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>                                                
                                                <td>L</td>
                                                <td><input type="text" name="hurdlestep_l_rawscore" id="hurdlestep_l_rawscore" className="form-control form-control-alternative" value={this.state.hurdlestep_l_rawscore}  onChange={evt => this.calculateRightLeft(evt,2)}/></td>
                                                <td><textarea rows="2" type="text" name="hurdlestep_l_comments" id="hurdlestep_l_comments" className="form-control form-control-alternative" defaultValue={scresponse.hurdlestep_l_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td rowSpan="2">In-Line Lunge</td>
                                                <td>R</td>
                                                <td><input type="text" name="inlinelunge_r_rawscore" id="inlinelunge_r_rawscore" className="form-control form-control-alternative" value={this.state.inlinelunge_r_rawscore}  onChange={evt => this.calculateRightLeft(evt,1)}/></td>
                                                <td rowSpan="2"><textarea rows="2" type="text" name="inlinelunge_r_finalscore" id="inlinelunge_r_finalscore" className="form-control form-control-alternative" value={this.state.inlinelunge_r_finalscore}  onChange={evt => this.calculateTotalScore(evt)} disabled></textarea></td>
                                                <td><textarea rows="2" type="text" name="inlinelunge_r_comments" id="inlinelunge_r_comments" className="form-control form-control-alternative" defaultValue={scresponse.inlinelunge_r_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>                                                
                                                <td>L</td>
                                                <td><input type="text" name="inlinelunge_l_rawscore" id="inlinelunge_l_rawscore" className="form-control form-control-alternative" value={this.state.inlinelunge_l_rawscore}  onChange={evt => this.calculateRightLeft(evt,2)}/></td>
                                                <td><textarea rows="2" type="text" name="inlinelunge_l_comments" id="inlinelunge_l_comments" className="form-control form-control-alternative" defaultValue={scresponse.inlinelunge_l_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td rowSpan="2">Shoulder Mobility </td>
                                                <td>R</td>
                                                <td><input type="text" name="shouldermobility_r_rawscore" id="shouldermobility_r_rawscore" className="form-control form-control-alternative" value={this.state.shouldermobility_r_rawscore}  onChange={evt => this.calculateRightLeft(evt,1)}/></td>
                                                <td rowSpan="2"><textarea rows="2" type="text" name="shouldermobility_r_finalscore" id="shouldermobility_r_finalscore" className="form-control form-control-alternative" value={this.state.shouldermobility_r_finalscore}  onChange={evt => this.calculateTotalScore(evt)} disabled></textarea></td>
                                                <td><textarea rows="2" type="text" name="shouldermobility_r_comments" id="shouldermobility_r_comments" className="form-control form-control-alternative" defaultValue={scresponse.shouldermobility_r_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>                                                
                                                <td>L</td>
                                                <td><input type="text" name="shouldermobility_l_rawscore" id="shouldermobility_l_rawscore" className="form-control form-control-alternative" value={this.state.shouldermobility_l_rawscore}  onChange={evt => this.calculateRightLeft(evt,2)}/></td>
                                                <td><textarea rows="2" type="text" name="shouldermobility_l_comments" id="shouldermobility_l_comments" className="form-control form-control-alternative" defaultValue={scresponse.shouldermobility_l_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td colSpan="2">Shoulder Clearance Test  </td>
                                                <td colSpan="3">
                                                       <select name="shoulderclearance_r_comments" id="shoulderclearance_r_comments" className="form-control form-control-alternative col-md-4" defaultValue={scresponse.shoulderclearance_r_comments}>
                                                         <option value=""></option>
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                             </tr>                                             
                                             <tr>
                                                <td rowSpan="2">Active Straight Leg Raise </td>
                                                <td>R</td>
                                                <td><input type="text" name="activestraightlegraise_r_rawscore" id="activestraightlegraise_r_rawscore" className="form-control form-control-alternative" value={this.state.activestraightlegraise_r_rawscore}  onChange={evt => this.calculateRightLeft(evt,1)}/></td>
                                                <td rowSpan="2"><textarea rows="2" type="text" name="activestraightlegraise_r_finalscore" id="activestraightlegraise_r_finalscore" className="form-control form-control-alternative" value={this.state.activestraightlegraise_r_finalscore}  onChange={evt => this.calculateTotalScore(evt)} disabled></textarea></td>
                                                <td><textarea rows="2" type="text" name="activestraightlegraise_r_comments" id="activestraightlegraise_r_comments" className="form-control form-control-alternative" defaultValue={scresponse.activestraightlegraise_r_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>                                                
                                                <td>L</td>
                                                <td><input type="text" name="activestraightlegraise_l_rawscore" id="activestraightlegraise_l_rawscore" className="form-control form-control-alternative" value={this.state.activestraightlegraise_l_rawscore}  onChange={evt => this.calculateRightLeft(evt,2)}/></td>
                                                <td><textarea rows="2" type="text" name="activestraightlegraise_l_comments" id="activestraightlegraise_l_comments" className="form-control form-control-alternative" defaultValue={scresponse.activestraightlegraise_l_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td colSpan="2">Trunk Stability Push Up </td>
                                                <td><input type="text" name="trunkstabilitypushup_rawscore" id="trunkstabilitypushup_rawscore" className="form-control form-control-alternative" value={this.state.trunkstabilitypushup_rawscore}  onChange={evt => this.calculateRawScore(evt)}/></td>
                                                <td><input type="text" name="trunkstabilitypushup_finalscore" id="trunkstabilitypushup_finalscore" className="form-control form-control-alternative" value={this.state.trunkstabilitypushup_finalscore}  onChange={evt => this.calculateTotalScore(evt)} disabled/></td>
                                                <td><textarea rows="2" type="text" name="trunkstabilitypushup_comments" id="trunkstabilitypushup_comments" className="form-control form-control-alternative" defaultValue={scresponse.trunkstabilitypushup_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td colSpan="2">Press up Clearing Test </td>                                               
                                                <td colSpan="3">
                                                       <select name="pressupclearing_comments" id="pressupclearing_comments" className="form-control form-control-alternative col-md-4" defaultValue={scresponse.pressupclearing_comments}>
                                                         <option value=""></option>
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                             </tr>
                                             <tr>
                                                <td rowSpan="2">Rotary Stability </td>
                                                <td>R</td>
                                                <td><input type="text" name="rotarystability_r_rawscore" id="rotarystability_r_rawscore" className="form-control form-control-alternative" value={this.state.rotarystability_r_rawscore}  onChange={evt => this.calculateRightLeft(evt,1)}/></td>
                                                <td rowSpan="2"><textarea rows="2"  type="text" name="rotarystability_r_finalscore" id="rotarystability_r_finalscore" className="form-control form-control-alternative" value={this.state.rotarystability_r_finalscore}  onChange={evt => this.calculateTotalScore(evt)} disabled></textarea></td>
                                                <td><textarea rows="2" type="text" name="rotarystability_r_comments" id="rotarystability_r_comments" className="form-control form-control-alternative" defaultValue={scresponse.rotarystability_r_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>                                                
                                                <td>L</td>
                                                <td><input type="text" name="rotarystability_l_rawscore" id="rotarystability_l_rawscore" className="form-control form-control-alternative" value={this.state.rotarystability_l_rawscore}  onChange={evt => this.calculateRightLeft(evt,2)}/></td>
                                                <td><textarea rows="2" type="text" name="rotarystability_l_comments" id="rotarystability_l_comments" className="form-control form-control-alternative" defaultValue={scresponse.rotarystability_l_comments} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td colSpan="2">Posterior Rocking Clearing Test </td>
                                                <td colSpan="3">
                                                       <select name="posteriorrocking_comments" id="posteriorrocking_comments" className="form-control form-control-alternative col-md-4" defaultValue={scresponse.posteriorrocking_comments}>
                                                         <option value=""></option>
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td> 
                                             </tr>
                                             <tr>
                                                <td colSpan="2">Total Score </td>
                                                <td></td>
                                                <td><input type="text" name="totalscore_finalscore" id="totalscore_finalscore" value={this.state.fmtotalscore} className="form-control form-control-alternative"/></td>
                                                <td></td>
                                             </tr>
                                          </tbody>                                          
                                    </table>  
                                    <div className="row">
                                       <div className="col-sm-12 col-md-6"> 
                                          <FormGroup>
                                             <Label for="Select">Impression </Label>
                                             <textarea rows="2" type="text" name="functionalmovement_impression" id="functionalmovement_impression" className="form-control form-control-alternative" defaultValue={scresponse.functionalmovement_impression} onChange={evt => this.handleInput(evt)}></textarea>
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-12 col-md-6"> 
                                          <FormGroup>
                                             <Label for="Select">Approach </Label>
                                             <textarea rows="2" type="text" name="functionalmovement_approach" id="functionalmovement_approach" className="form-control form-control-alternative" defaultValue={scresponse.functionalmovement_approach} onChange={evt => this.handleInput(evt)}></textarea>
                                          </FormGroup>
                                       </div>
                                 </div>         
                              </RctCollapsibleCard>
                           </div>
                           
                            <div className="col-sm-12 col-md-8">
                              <RctCollapsibleCard heading="MOVEMENT PATTERN ASSESSMENT"> 
                                    <table className="table align-items-center table-flush">
                                          <thead className="thead-light">
                                             <th className="text-center" style={{width: "30%"}}>Movement</th>
                                             <th className="text-center" style={{width: "15%"}}>Score</th>
                                             <th className="text-center">Remarks</th>
                                          </thead>
                                          <tbody>
                                          <tr>                                              
                                             <td>Box Jump</td>
                                                <td><input type="text" name="boxjump_score" id="boxjump_score" value={this.state.boxjump_score} onChange={evt => this.isNumeric(evt)} className="form-control form-control-alternative"/></td>
                                                <td><textarea rows="2" type="text" name="boxjump_remarks" id="boxjump_remarks" className="form-control form-control-alternative" defaultValue={scresponse.boxjump_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>                                                
                                                <td>Single Leg Hop Right</td>
                                                <td><input type="text" name="singlerighthopright_score" id="singlerighthopright_score" className="form-control form-control-alternative" value={this.state.singlerighthopright_score} onChange={evt => this.isNumeric(evt)}/></td>
                                                <td><textarea rows="2" type="text" name="singlerighthopright_remarks" id="singlerighthopright_remarks" className="form-control form-control-alternative" defaultValue={scresponse.singlerighthopright_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>      
                                                <td>Single Leg Hop Left</td>
                                                <td><input type="text" name="singlerighthopleft_score" id="singlerighthopleft_score" className="form-control form-control-alternative" value={this.state.singlerighthopleft_score} onChange={evt => this.isNumeric(evt)}/></td>
                                                <td><textarea rows="2" type="text" name="singlerighthopleft_remarks" id="singlerighthopleft_remarks" className="form-control form-control-alternative" defaultValue={scresponse.singlerighthopleft_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td>Deadlift</td>
                                                <td><input type="text" name="deadlift_score" id="deadlift_score" className="form-control form-control-alternative" value={this.state.deadlift_score} onChange={evt => this.isNumeric(evt)}/></td>
                                                <td><textarea rows="2" type="text" name="deadlift_remarks" id="deadlift_remarks" className="form-control form-control-alternative" defaultValue={scresponse.deadlift_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr> 
                                                <td>Pull Up/Chin Up/Inverted Row</td>
                                                <td><input type="text" name="pullup_score" id="pullup_score" className="form-control form-control-alternative" value={this.state.pullup_score} onChange={evt => this.isNumeric(evt)}/></td>
                                                <td><textarea rows="2" type="text" name="pullup_remarks" id="pullup_remarks" className="form-control form-control-alternative" defaultValue={scresponse.pullup_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td>Push Up</td>
                                                <td><input type="text" name="pushup_score" id="pushup_score" className="form-control form-control-alternative" value={this.state.pushup_score} onChange={evt => this.isNumeric(evt)}/></td>
                                                <td><textarea rows="2" type="text" name="pushup_remarks" id="pushup_remarks" className="form-control form-control-alternative" defaultValue={scresponse.pushup_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr> 
                                                <td>Plank</td>
                                                <td><input type="text" name="plank_score" id="plank_score" className="form-control form-control-alternative" value={this.state.plank_score} onChange={evt => this.isNumeric(evt)}/></td>
                                                <td><textarea rows="2" type="text" name="plank_remarks" id="plank_remarks" className="form-control form-control-alternative" defaultValue={scresponse.plank_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td>Medicine Ball Rotational Throw</td>
                                                <td><input type="text" name="medicineball_score" id="medicineball_score" className="form-control form-control-alternative" value={this.state.medicineball_score} onChange={evt => this.isNumeric(evt)}/></td>
                                                <td><textarea rows="2" type="text" name="medicineball_remarks" id="medicineball_remarks" className="form-control form-control-alternative" defaultValue={scresponse.medicineball_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             
                                          </tbody>
                                    </table>  
                                    <div className="row">
                                       <div className="col-sm-12 col-md-6"> 
                                          <FormGroup>
                                             <Label for="Select">Impression </Label>
                                             <textarea rows="2" type="text" name="movementpattern_impression" id="movementpattern_impression" className="form-control form-control-alternative" defaultValue={scresponse.movementpattern_impression} onChange={evt => this.handleInput(evt)}></textarea>
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-12 col-md-6"> 
                                          <FormGroup>
                                             <Label for="Select">Approach </Label>
                                             <textarea rows="2" type="text" name="movementpattern_approach" id="movementpattern_approach" className="form-control form-control-alternative" defaultValue={scresponse.movementpattern_approach} onChange={evt => this.handleInput(evt)}></textarea>
                                          </FormGroup>
                                       </div>
                                 </div>         
                              </RctCollapsibleCard>
                           </div>
                           <div className="col-sm-12 col-md-12">
                              <RctCollapsibleCard heading="PERFORMANCE TEST ">                                        
                                       <div>  
                                          
                                          <span style={{fontSize:"15px", padding:"15px", fontWeight:"500"}}><input type="checkbox" color="primary" name="onermtestcheck" checked={this.state.rmtest} value="1" onChange={e => this.handleAddCheckChange(1)} style={{width:"18px", height:"18px", marginRight:"5px"}}/>
                                          1RM TEST</span> 
                                          
                                          <span style={{fontSize:"15px", padding:"15px", fontWeight:"500"}}><input type="checkbox" color="primary" name ="aerobicfitnesscheck" checked={this.state.aerobictest} value="1" onChange={e => this.handleAddCheckChange(2)} style={{width:"18px", height:"18px", marginRight:"5px"}}/>
                                             AEROBIC FITNESS TEST </span>
                                          
                                          <span style={{fontSize:"15px", padding:"15px", fontWeight:"500"}}><input type="checkbox" color="primary" name ="lowerbodypowercheck" checked={this.state.lowerbodytest} value="1" onChange={e => this.handleAddCheckChange(3)} style={{width:"18px", height:"18px", marginRight:"5px"}}/>
                                             LOWER BODY POWER TEST</span>
                                          
                                          <span style={{fontSize:"15px", padding:"15px", fontWeight:"500"}}><input type="checkbox" color="primary" name ="upperbodystrengthcheck" checked={this.state.upperbody} value="1" onChange={e => this.handleAddCheckChange(4)} style={{width:"18px", height:"18px", marginRight:"5px"}}/>
                                             UPPER BODY STRENGTH TEST</span>
                                          
                                          <span style={{fontSize:"15px", padding:"15px", fontWeight:"500"}}><input type="checkbox" color="primary" name ="accelerationspeedcheck" checked={this.state.acceleration} value="1" onChange={e => this.handleAddCheckChange(5)} style={{width:"18px", height:"18px", marginRight:"5px"}}/>
                                             ACCELERATION SPEED </span>
                                          
                                          <span style={{fontSize:"15px", padding:"15px", fontWeight:"500"}}><input type="checkbox" color="primary" name ="coreendurancecheck" checked={this.state.coreendurance} value="1" onChange={e => this.handleAddCheckChange(6)} style={{width:"18px", height:"18px", marginRight:"5px"}}/>
                                             CORE ENDURANCE TEST </span>         

                                       </div>
                                       
                                 </RctCollapsibleCard>
                           </div>

                           {this.state.rmtest &&
                                <div className="col-sm-12 col-md-8">
                                    <RctCollapsibleCard heading="1RM TEST"> 
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <th className="text-center">Test</th>
                                                    <th colSpan="2" className="text-center">Estimated RM (kg)</th>
                                                    <th className="text-center">1RM Value (kg)</th>
                                                    <th className="text-center">Remarks</th>
                                                </thead>
                                                <tbody>
                                                    <tr>                                              
                                                        <td>1RM Clean</td>
                                                        <td style={{width: "20%"}}>
                                                         <select className="form-control form-control-alternative" name="rmcleanestimate_rm" id="rmcleanestimate_rm" value={this.state.rmcleanestimate_rm} onChange={evt => this.setState({rmcleanestimate_rm: evt.target.value})}>
                                                               <option value=""> </option>
                                                               {(() => {
                                                                     let td = [];
                                                                     for (let i = 1; i <=10; i++) {
                                                                     td.push(<option value={i}>{i} RM</option>);
                                                                     }
                                                                     return td;
                                                                  })()}
                                                          </select>
                                                        </td>
                                                        <td style={{width: "15%"}}><input type="text" name="rmcleanestimate_value" id="rmcleanestimate_value" className="form-control form-control-alternative" value={this.state.rmcleanestimate_value} onChange={evt => this.rmCalculate(evt,1)} /></td>
                                                        <td style={{width: "17%"}}><input type="text" name="rmclean_value" id="rmclean_value" className="form-control form-control-alternative" value={this.state.rmclean_value} disabled/></td>                                                        
                                                        <td><textarea rows="2" type="text" name="rmclean_remarks" id="rmclean_remarks" className="form-control form-control-alternative" defaultValue={scresponse.rmclean_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                    </tr>
                                                    <tr>                                                
                                                        <td>1RM Back Squat</td>
                                                        <td>
                                                         <select className="form-control form-control-alternative" name="rmsquatestimate_rm" id="rmsquatestimate_rm" value={this.state.rmsquat_rm} onChange={evt => this.setState({rmsquat_rm: evt.target.value})}>
                                                               <option value=""> </option>
                                                               {(() => {
                                                                     let td = [];
                                                                     for (let i = 1; i <=10; i++) {
                                                                     td.push(<option value={i}>{i} RM</option>);
                                                                     }
                                                                     return td;
                                                                  })()}
                                                         </select>
                                                        </td>
                                                        <td><input type="text" name="rmsquatestimate_value" id="rmsquatestimate_value" className="form-control form-control-alternative" value={this.state.rmsquatestimate_value} onChange={evt => this.rmCalculate(evt,2)}/></td>
                                                        <td><input type="text" name="rmsquat_value" id="rmsquat_value" className="form-control form-control-alternative" value={this.state.rmsquat_value} disabled/></td>                                                        
                                                        <td><textarea rows="2" type="text" name="rmsquat_remarks" id="rmsquat_remarks" className="form-control form-control-alternative" defaultValue={scresponse.rmsquat_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                    </tr>
                                                    <tr>      
                                                        <td>1RM Bench Press</td>
                                                        <td>
                                                         <select className="form-control form-control-alternative" name="rmpressestimate_rm" id="rmpressestimate_rm" value={this.state.rmpress_rm} onChange={evt => this.setState({rmpress_rm: evt.target.value})}>
                                                               <option value=""> </option>
                                                               {(() => {
                                                                     let td = [];
                                                                     for (let i = 1; i <=10; i++) {
                                                                     td.push(<option value={i}>{i} RM</option>);
                                                                     }
                                                                     return td;
                                                                  })()}
                                                         </select>
                                                        </td>
                                                        <td><input type="text" name="rmpressestimate_value" id="rmpressestimate_value" className="form-control form-control-alternative" value={this.state.rmpressestimate_value} onChange={evt => this.rmCalculate(evt,3)}/></td>
                                                        <td><input type="text" name="rmpress_value" id="rmpress_value" className="form-control form-control-alternative" value={this.state.rmpress_value} disabled/></td>
                                                        <td><textarea rows="2" type="text" name="rmpress_remarks" id="rmpress_remarks" className="form-control form-control-alternative" defaultValue={scresponse.rmpress_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                    </tr>                                                                                    
                                                </tbody>
                                            </table> 
                                    </RctCollapsibleCard>
                                </div>
                           }
                           {this.state.aerobictest &&
                                <div className="col-sm-12 col-md-8">
                                    <RctCollapsibleCard heading="AEROBIC FITNESS TEST "> 
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <th className="text-center">Test</th>
                                                    <th className="text-center" style={{width: "12%"}}>Time (min)</th>
                                                    <th className="text-center" style={{width: "15%"}}>VO<sup style={{top: "5px"}}>2</sup> max (ml|kg|min)</th>
                                                    <th className="text-center">Remarks</th>
                                                </thead>
                                                <tbody>
                                                    <tr>                                              
                                                        <td>2.4km Run Test </td>
                                                        <td><input type="text" name="aerobicfitness_time" id="aerobicfitness_time" className="form-control form-control-alternative" value={this.state.aerobicfitness_time} onChange={evt => this.calculateVO(evt)}/></td>
                                                        <td><input type="text" name="aerobicfitness_vo" id="aerobicfitness_vo" className="form-control form-control-alternative" value={this.state.aerobicfitness_vo} disabled/></td>
                                                        <td><textarea rows="2" type="text" name="aerobicfitness_remarks" id="aerobicfitness_remarks" className="form-control form-control-alternative" defaultValue={scresponse.aerobicfitness_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                    </tr>                                                                                                                                    
                                                </tbody>
                                            </table> 
                                    </RctCollapsibleCard>
                                </div>
                            }
                            {this.state.lowerbodytest &&
                                <div className="col-sm-12 col-md-8">
                                    <RctCollapsibleCard heading="LOWER BODY POWER TEST"> 
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <th className="text-center">Test</th>
                                                    <th className="text-center" style={{width: "15%"}}>Trial 1 (cm)</th>
                                                    <th className="text-center" style={{width: "15%"}}>Trial 2 (cm)</th>
                                                    <th className="text-center" style={{width: "15%"}}>Trial 3 (cm)</th>
                                                    <th className="text-center" style={{width: "12%"}}>Result (cm)</th>
                                                    <th className="text-center">Remarks</th>
                                                </thead>
                                                <tbody>
                                                    <tr>                                              
                                                        <td>Vertical Jump </td>
                                                        <td><input type="text" name="lowerboay_trial1" id="lowerboay_trial1" className="form-control form-control-alternative" value={this.state.lowerboay_trial1} onChange={evt => this.lowerbody(evt,1)}/></td>
                                                        <td><input type="text" name="lowerboay_trial2" id="lowerboay_trial2" className="form-control form-control-alternative" value={this.state.lowerboay_trial2} onChange={evt => this.lowerbody(evt,2)}/></td>
                                                        <td><input type="text" name="lowerboay_trial3" id="lowerboay_trial3" className="form-control form-control-alternative" value={this.state.lowerboay_trial3} onChange={evt => this.lowerbody(evt,3)}/></td>
                                                        <td><input type="text" name="lowerboay_result" id="lowerboay_result" className="form-control form-control-alternative" value={this.state.lowerboay_result} disabled/></td>
                                                        <td><textarea rows="2" type="text" name="lowerboay_remarks" id="lowerboay_remarks" className="form-control form-control-alternative" defaultValue={scresponse.lowerboay_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                    </tr>                                                                                                                                    
                                                </tbody>
                                            </table> 
                                    </RctCollapsibleCard>
                                </div>
                            }

                            {this.state.upperbody &&
                                <div className="col-sm-12 col-md-8">
                                    <RctCollapsibleCard heading="UPPER BODY STRENGTH TEST"> 
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <th className="text-center" style={{width: "30%"}}>Test</th>
                                                    <th className="text-center" style={{width: "20%"}}>Result (no)</th>
                                                    <th className="text-center">Remarks</th>
                                                </thead>
                                                <tbody>
                                                    <tr>                                              
                                                        <td>Pull Up (maximum no)</td>
                                                        <td><input type="text" name="upperbodystrength_score" id="upperbodystrength_score" className="form-control form-control-alternative" defaultValue={scresponse.upperbodystrength_score}/></td>
                                                        <td><textarea rows="2" type="text" name="upperbodystrength_remarks" id="upperbodystrength_remarks" className="form-control form-control-alternative" defaultValue={scresponse.upperbodystrength_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                    </tr>                                                                                                                                    
                                                </tbody>
                                            </table> 
                                    </RctCollapsibleCard>
                                </div>
                            }

                            {this.state.acceleration &&
                                <div className="col-sm-12 col-md-8">
                                    <RctCollapsibleCard heading="ACCELERATION SPEED"> 
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <th className="text-center">Test</th>
                                                    <th className="text-center" style={{width: "15%"}}>Trial 1 (sec)</th>
                                                    <th className="text-center" style={{width: "15%"}}>Trial 2 (sec)</th>
                                                    <th className="text-center" style={{width: "15%"}}>Trial 3 (sec)</th>
                                                    <th className="text-center" style={{width: "12%"}}>Result (sec)</th>
                                                    <th className="text-center">Remarks</th>
                                                </thead>
                                                <tbody>
                                                    <tr>                                              
                                                        <td>20m Sprint Speed</td>
                                                        <td><input type="text" name="acceleration_trial1" id="acceleration_trial1" className="form-control form-control-alternative" value={this.state.acceleration_trial1} onChange={evt => this.acceleration(evt,1)}/></td>
                                                        <td><input type="text" name="acceleration_trial2" id="acceleration_trial2" className="form-control form-control-alternative" value={this.state.acceleration_trial2} onChange={evt => this.acceleration(evt,2)}/></td>
                                                        <td><input type="text" name="acceleration_trial3" id="acceleration_trial3" className="form-control form-control-alternative" value={this.state.acceleration_trial3} onChange={evt => this.acceleration(evt,3)}/></td>
                                                        <td><input type="text" name="acceleration_result" id="acceleration_result" className="form-control form-control-alternative" value={this.state.acceleration_result} disabled/></td>
                                                        <td><textarea rows="2" type="text" name="acceleration_remarks" id="acceleration_remarks" className="form-control form-control-alternative" defaultValue={scresponse.acceleration_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                    </tr>                                                                                                                                    
                                                </tbody>
                                            </table> 
                                    </RctCollapsibleCard>
                                </div>
                            }

                            {this.state.coreendurance &&
                                <div className="col-sm-12 col-md-8">
                                    <RctCollapsibleCard heading="CORE ENDURANCE TEST"> 
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <th className="text-center" style={{width: "30%"}}>Test</th>
                                                    <th className="text-center" style={{width: "20%"}}>Result (sec)</th>
                                                    <th className="text-center">Remarks</th>
                                                </thead>
                                                <tbody>
                                                    <tr>                                              
                                                        <td>Plank (maximum time)</td>
                                                        <td><input type="text" name="coreendurance_score" id="coreendurance_score" className="form-control form-control-alternative" defaultValue={scresponse.coreendurance_score}/></td>
                                                        <td><textarea rows="2" type="text" name="coreendurance_remarks" id="coreendurance_remarks" className="form-control form-control-alternative" defaultValue={scresponse.coreendurance_remarks} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                    </tr>                                                                                                                                    
                                                </tbody>
                                            </table> 
                                    </RctCollapsibleCard>
                                </div>
                            }   
                              
                              <div className="col-sm-12 col-md-8">
                                 <RctCollapsibleCard heading="KEY PERFORMANCE INDICATORS"> 
                                       <table className="table align-items-center table-flush">
                                             <thead className="thead-light">
                                                   <th className="text-center">Club Head Speed (miles/hr) </th>
                                                   <th className="text-center">Driver Carry Distance (yards)</th>
                                             </thead>
                                             <tbody>
                                                <tr>
                                                <td><textarea rows="2" type="text" name="clubhd_box" id="clubhd_box" className="form-control form-control-alternative" defaultValue={scresponse.clubhd_box}></textarea></td>
                                                <td><textarea rows="2" type="text" name="drivercarry_distance" id="drivercarry_distance" className="form-control form-control-alternative" defaultValue={scresponse.drivercarry_distance}></textarea></td>
                                                </tr>
                                             </tbody>
                                       </table>      
                                 </RctCollapsibleCard>                             
                              </div>

                              <div className="col-sm-12 col-md-8">
                                 <RctCollapsibleCard heading="PLAN OF ACTION"> 
                                          <table className="table align-items-center table-flush">
                                             <thead className="thead-light">
                                                 <tr>
                                                   <th rowSpan="2" className="text-center">Impression</th>
                                                   <th className="text-center" colSpan="2">Goal</th>
                                                   <th rowSpan="2" className="text-center">Approach</th>
                                                 </tr>
                                                 <tr>
                                                      <td>Short Term Goals</td>
                                                      <td>Long Term Goals</td>
                                                 </tr>   
                                             </thead>
                                             <tbody>
                                                   <tr>                                              
                                                      <td><textarea rows="10" type="text" name="clubhd_impression" id="clubhd_impression" className="form-control form-control-alternative" defaultValue={scresponse.clubhd_impression} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                      <td><textarea rows="10" type="text" name="clubhdshrtgoal1" id="clubhdshrtgoal1" className="form-control form-control-alternative" defaultValue={scresponse.clubhdshrtgoal1} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                      <td><textarea rows="10" type="text" name="clubhdlonggoal1" id="clubhdlonggoal1" className="form-control form-control-alternative" defaultValue={scresponse.clubhdlonggoal1} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                      <td><textarea rows="10" type="text" name="clubhd_approach" id="clubhd_approach" className="form-control form-control-alternative" defaultValue={scresponse.clubhd_approach} onChange={evt => this.handleInput(evt)}></textarea></td>
                                                   </tr>                                                                                                                     
                                             </tbody>
                                          </table> 
                                 </RctCollapsibleCard>
                              </div>

                        </div>
                        
                        <div className="form-group">
                           <input type="hidden" name="userid" defaultValue={scresponse.user_id}/>
                           <input type="hidden" name="pa_id" defaultValue={scresponse.scID}/>
                           <input type="hidden" name="assdate" defaultValue={scresponse.assessment_date}/>
                           <input type="hidden" name="quarter" defaultValue={scresponse.quarter}/>
                           <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                           <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} value="Back" />
                        </div>
                       
                     </form> 
                  </div>

            </div>
            
            );
   }
}


const mapStateToProps = ({ scassessment }) => {
    const { scresponse, loading } = scassessment;
	return { scresponse, loading };
}

export default connect(mapStateToProps, {
    fetchMskAssessment,
    editSCAssessment
})(EditMSKElements); 
